// import React from 'react';

// const SmartTools = () => {
//   const containerStyle = {
//     display: 'grid',
//     gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
//     gap: '20px',
//     marginTop: '20px',
//     marginBottom: '30px',
//   };

//   const cardStyle = {
//     backgroundColor: '#f9fff9',
//     padding: '20px',
//     borderRadius: '12px',
//     boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
//   };

//   const titleStyle = {
//     fontSize: '18px',
//     fontWeight: 'bold',
//     marginBottom: '10px',
//   };

//   const sectionStyle = {
//     marginBottom: '10px',
//   };

//   return (
//     <div>
//       <h3>📊 Regional Agriculture Insights</h3>
//       <div style={containerStyle}>
//         {/* Card 1: Crop Insights */}
//         <div style={cardStyle}>
//           <div style={titleStyle}>🌾 Regional Crop Insights</div>
//           <div style={sectionStyle}><strong>State:</strong> Maharashtra</div>
//           <div style={sectionStyle}><strong>District:</strong> Pune</div>
//           <div style={sectionStyle}><strong>Crop:</strong> Wheat</div>
//           <div style={sectionStyle}><strong>Area Under Cultivation:</strong> 1,20,000 acres</div>
//           <div style={sectionStyle}>
//             <strong>Other Suitable Crops:</strong>
//             <ul>
//               <li>Chickpea</li>
//               <li>Onion</li>
//               <li>Tur</li>
//             </ul>
//           </div>
//         </div>

//         {/* Card 2: Crop Pattern Analysis */}
//         <div style={cardStyle}>
//           <div style={titleStyle}>📈 Crop Pattern Analysis</div>
//           <div style={sectionStyle}><strong>Last 3-Year Trend:</strong></div>
//           <ul>
//             <li>2022 – Dominated by Wheat and Sugarcane</li>
//             <li>2023 – Shift towards Pulses due to water scarcity</li>
//             <li>2024 – Balanced mix with increasing horticulture</li>
//           </ul>
//           <div style={sectionStyle}><strong>Future Suggestion:</strong> Diversify with high-yield pulses and vegetables</div>
//         </div>

//         {/* Card 3: Soil Type Classification */}
//         <div style={cardStyle}>
//           <div style={titleStyle}>🧪 Soil Type Classification</div>
//           <div style={sectionStyle}><strong>Soil Type:</strong> Black Cotton Soil</div>
//           <div style={sectionStyle}><strong>Properties:</strong></div>
//           <ul>
//             <li>High moisture retention</li>
//             <li>Rich in minerals like iron & calcium</li>
//             <li>Suitable for cotton, wheat, jowar, soybean</li>
//           </ul>
//           <div style={sectionStyle}><strong>Recommendation:</strong> Deep ploughing + controlled irrigation</div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default SmartTools;

import React, { useState, useEffect } from 'react';


// const allIndianStates = [
//   'Andhra Pradesh',
//   'Arunachal Pradesh',
//   'Assam',
//   'Bihar',
//   'Chhattisgarh',
//   'Goa',
//   'Gujarat',
//   'Haryana',
//   'Himachal Pradesh',
//   'Jharkhand',
//   'Karnataka',
//   'Kerala',
//   'Madhya Pradesh',
//   'Maharashtra',
//   'Manipur',
//   'Meghalaya',
//   'Mizoram',
//   'Nagaland',
//   'Odisha',
//   'Punjab',
//   'Rajasthan',
//   'Sikkim',
//   'Tamil Nadu',
//   'Telangana',
//   'Tripura',
//   'Uttar Pradesh',
//   'Uttarakhand',
//   'West Bengal'
// ];

const SmartTools = () => {
  const [mapData, setMapData] = useState(null);
  const [selectedState, setSelectedState] = useState('');
  const [districtData, setDistrictData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  
  // User role states
  const [userRole, setUserRole] = useState('farmer');
  const [userSelectedState, setUserSelectedState] = useState('');
  const [userSelectedDistrict, setUserSelectedDistrict] = useState('');

  // Get user data from localStorage
  useEffect(() => {
    const userData = localStorage.getItem('user');
    if (userData) {
      try {
        const user = JSON.parse(userData);
        setUserRole(user.role || 'farmer');
        setUserSelectedState(user.selectedState || '');
        setUserSelectedDistrict(user.selectedDistrict || '');
        
        // Auto-select user's state for all users
        if (user.selectedState) {
          console.log('Setting selectedState for user:', user.selectedState);
          setSelectedState(user.selectedState);
        } else {
          // Default
          setSelectedState('Maharashtra');
        }
      } catch (error) {
        console.error('Error parsing user data:', error);
        setSelectedState('Maharashtra'); // Fallback
      }
    } else {
      // No user data, default to farmer with Maharashtra
      setSelectedState('Maharashtra');
    }
  }, []);

  // Soil type mapping for Indian states
  const soilMapping = {
    'Maharashtra': {
      type: 'Black Cotton Soil (Regur)',
      properties: ['High moisture retention', 'Rich in iron, calcium & magnesium', 'Excellent for cotton, wheat, jowar, soybean'],
      recommendation: 'Deep ploughing + controlled irrigation for optimal yield'
    },
    'Punjab': {
      type: 'Alluvial Soil',
      properties: ['High fertility', 'Good water retention', 'Suitable for wheat, rice, sugarcane, cotton'],
      recommendation: 'Regular crop rotation to maintain soil health'
    },
    'Uttar Pradesh': {
      type: 'Alluvial Soil',
      properties: ['Rich in potash', 'Good drainage', 'Ideal for wheat, rice, sugarcane, pulses'],
      recommendation: 'Use of organic fertilizers for long-term productivity'
    },
    'West Bengal': {
      type: 'Alluvial & Laterite Soil',
      properties: ['High organic content', 'Moisture retentive', 'Best for rice, jute, tea, vegetables'],
      recommendation: 'Proper drainage systems to prevent waterlogging'
    },
    'Gujarat': {
      type: 'Black & Alluvial Soil',
      properties: ['Moderate fertility', 'Good for cotton & groundnut', 'Suitable for cash crops'],
      recommendation: 'Drip irrigation for water conservation'
    },
    'Rajasthan': {
      type: 'Arid & Desert Soil',
      properties: ['Low moisture content', 'Sandy texture', 'Suitable for bajra, jowar, pulses'],
      recommendation: 'Water conservation techniques + drought-resistant crops'
    },
    'Tamil Nadu': {
      type: 'Red & Black Soil',
      properties: ['Rich in iron', 'Good drainage', 'Ideal for rice, sugarcane, cotton, groundnut'],
      recommendation: 'Soil enrichment with organic matter'
    },
    'Karnataka': {
      type: 'Red & Black Soil',
      properties: ['Moderate fertility', 'Good for ragi, rice, cotton', 'Suitable for diverse crops'],
      recommendation: 'Balanced use of fertilizers + crop rotation'
    },
    'Andhra Pradesh': {
      type: 'Red & Black Soil',
      properties: ['Rich in iron oxide', 'Good for rice, cotton, tobacco', 'Diverse soil types'],
      recommendation: 'Integrated nutrient management for sustainability'
    },
    'Madhya Pradesh': {
      type: 'Black Soil (Malwa Plateau)',
      properties: ['High clay content', 'Rich in calcium', 'Excellent for wheat, soybean, cotton'],
      recommendation: 'Contour ploughing to prevent soil erosion'
    },
    'Bihar': {
      type: 'Alluvial Soil',
      properties: ['Very fertile', 'Rich in nutrients', 'Perfect for rice, wheat, maize, pulses'],
      recommendation: 'Proper flood management + crop diversification'
    },
    'Haryana': {
      type: 'Alluvial Soil',
      properties: ['High fertility', 'Good texture', 'Ideal for wheat, rice, cotton, sugarcane'],
      recommendation: 'Efficient water management + balanced fertilization'
    }
  };

  // Fetch map data on component mount
  useEffect(() => {
    setIsLoading(true);
    fetch(`${process.env.REACT_APP_API_URL || (process.env.REACT_APP_API_URL || (process.env.REACT_APP_API_URL || "http://localhost:5001"))}/api/india-crops`)
      .then(response => response.json())
      .then(data => {
        setMapData(data);
        setIsLoading(false);
      })
      .catch(error => {
        console.error('Error fetching map data:', error);
        setIsLoading(false);
      });
  }, []);

  // Fetch district data when state changes
  useEffect(() => {
    if (selectedState) {
      console.log('Fetching district data for state:', selectedState);
      fetch(`${process.env.REACT_APP_API_URL || (process.env.REACT_APP_API_URL || (process.env.REACT_APP_API_URL || (process.env.REACT_APP_API_URL || "http://localhost:5001")))}/api/districts/${encodeURIComponent(selectedState)}`)
        .then(response => response.json())
        .then(data => {
          console.log('District data received:', data);
          setDistrictData(data);
        })
        .catch(error => {
          console.error('Error fetching district data:', error);
        });
    }
  }, [selectedState]);

  // Get crop icon
  const getCropIcon = (cropName) => {
    const icons = {
      'Rice': '🌾', 'Wheat': '🌾', 'Cotton': '🌱', 'Sugarcane': '🎋', 
      'Groundnut': '🥜', 'Maize': '🌽', 'Jowar': '🌾', 'Bajra': '🌾', 
      'Pulses': '🫘', 'Jute': '🌿', 'Tea': '🍃', 'Coffee': '☕',
      'Coconut': '🥥', 'Rubber': '🌳', 'Spices': '🌶️', 'Barley': '🌾', 
      'Gram': '🫘', 'Mustard': '🌻', 'Tobacco': '🍃', 'Onion': '🧅'
    };
    return icons[cropName] || '🌾';
  };

  // Generate crop suggestions based on primary/secondary crops
  const getSuitableCrops = (stateName) => {
    if (!mapData || !mapData.stateCrops || !mapData.stateCrops[stateName]) {
      return ['Wheat', 'Rice', 'Pulses'];
    }
    
    const stateCrops = mapData.stateCrops[stateName];
    const allCrops = mapData.legend?.crops || [];
    
    // Filter out primary and secondary crops, return top alternatives
    const alternatives = allCrops
      .filter(crop => !stateCrops.includes(crop))
      .slice(0, 4);
    
    return alternatives.length > 0 ? alternatives : ['Wheat', 'Rice', 'Pulses'];
  };

  // Generate trend analysis
  const generateTrendAnalysis = (stateName) => {
    if (!mapData || !mapData.stateCrops || !mapData.stateCrops[stateName]) {
      return [
        '2022 – Traditional crop patterns maintained',
        '2023 – Gradual shift towards diversification',
        '2024 – Balanced approach with climate-resilient crops'
      ];
    }

    const primaryCrop = mapData.stateCrops[stateName][0];
    const secondaryCrop = mapData.stateCrops[stateName][1];

    return [
      `2022 – Dominated by ${primaryCrop} and ${secondaryCrop || 'traditional crops'}`,
      `2023 – Gradual shift towards diversification and sustainable farming`,
      `2024 – Increased focus on ${primaryCrop} with balanced crop rotation`
    ];
  };

  // Get cultivation area estimate
  const getCultivationArea = (stateName) => {
    if (!mapData || !mapData.cropProduction) return 'Data not available';
    
    const primaryCrop = mapData.stateCrops?.[stateName]?.[0];
    if (!primaryCrop) return 'Data not available';
    
    const production = mapData.cropProduction[primaryCrop];
    if (!production) return 'Data not available';
    
    // Rough estimate: 1 MT production ≈ 0.8-1.5 acres (varies by crop)
    const estimatedAcres = (production * 1000).toFixed(0);
    return `${Number(estimatedAcres).toLocaleString()} acres (estimated)`;
  };

  // Get title based on user role
  const getTitle = () => {
    switch (userRole) {
      case 'state':
        return `📊 ${userSelectedState} State Agriculture Insights`;
      case 'district':
        return `📊 ${userSelectedDistrict} District Agriculture Insights`;
      default:
        return '📊 Regional Agriculture Insights';
    }
  };

  // All users can select state
  const showStateSelection = true;

  const containerStyle = {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
    gap: '20px',
    marginTop: '20px',
    marginBottom: '30px',
  };

  const cardStyle = {
    backgroundColor: '#f9fff9',
    padding: '20px',
    borderRadius: '12px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
    border: '1px solid #e0e0e0',
    transition: 'all 0.3s ease',
  };

  const titleStyle = {
    fontSize: '18px',
    fontWeight: 'bold',
    marginBottom: '15px',
    color: '#2E7D32',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  };

  const sectionStyle = {
    marginBottom: '12px',
    fontSize: '14px',
    lineHeight: '1.6',
  };

  const selectStyle = {
    padding: '10px 15px',
    fontSize: '16px',
    borderRadius: '8px',
    border: '2px solid #4CAF50',
    backgroundColor: 'white',
    cursor: 'pointer',
    marginBottom: '20px',
    width: '100%',
    maxWidth: '100%',
  };

  const labelStyle = {
    fontSize: '16px',
    fontWeight: '600',
    marginBottom: '8px',
    color: '#333',
  };

  if (isLoading) {
    return (
      <div style={{ textAlign: 'center', padding: '40px' }}>
        <div style={{ fontSize: '40px', marginBottom: '15px' }}>🌾</div>
        <div>Loading Agricultural Insights...</div>
      </div>
    );
  }

  if (!mapData) {
    return (
      <div style={{ textAlign: 'center', padding: '40px', color: '#d32f2f' }}>
        <div style={{ fontSize: '40px', marginBottom: '15px' }}>⚠️</div>
        <div>Unable to load data. Please try again.</div>
      </div>
    );
  }

//  const statesList = Array.from(
//   new Set([
//     ...allIndianStates,
//     ...Object.keys(mapData.stateCrops || {})
//   ])
// ).sort();

 
  const statesList = Object.keys(mapData.stateCrops || {}).sort();

  const soilInfo = soilMapping[selectedState] || soilMapping['Maharashtra'];
  const primaryCrop = mapData.stateCrops?.[selectedState]?.[0] || 'N/A';
  const secondaryCrop = mapData.stateCrops?.[selectedState]?.[1] || 'N/A';
  const suitableCrops = getSuitableCrops(selectedState);
  const trends = generateTrendAnalysis(selectedState);
  const cultivationArea = getCultivationArea(selectedState);

  return (
    <div style={{ padding: '20px' }}>
      <h3 style={{ fontSize: '24px', fontWeight: 'bold', marginBottom: '20px', color: '#2E7D32' }}>
        {getTitle()}
      </h3>

      {/* State Selection - Only show for farmers */}
      {showStateSelection && (
        <div style={{ marginBottom: '20px' }}>
          <div style={labelStyle}>Select State:</div>
          <select 
            style={selectStyle}
            value={selectedState}
            onChange={(e) => setSelectedState(e.target.value)}
          >
            {statesList.map(state => (
              <option key={state} value={state}>{state}</option>
            ))}
          </select>
        </div>
      )}


      <div style={containerStyle}>
        {/* Card 1: Crop Insights */}
        <div 
          style={cardStyle}
          onMouseEnter={(e) => {
            e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)';
            e.currentTarget.style.transform = 'translateY(-2px)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.05)';
            e.currentTarget.style.transform = 'translateY(0)';
          }}
        >
          <div style={titleStyle}>
            <span>🌾</span>
            <span>Regional Crop Insights</span>
          </div>
          <div style={sectionStyle}>
            <strong>State:</strong> {selectedState}
          </div>
          <div style={sectionStyle}>
            <strong>Total Districts:</strong> {districtData?.totalDistricts || 'Loading...'}
          </div>
          <div style={sectionStyle}>
            <strong>Primary Crop:</strong> {getCropIcon(primaryCrop)} {primaryCrop}
          </div>
          <div style={sectionStyle}>
            <strong>Secondary Crop:</strong> {getCropIcon(secondaryCrop)} {secondaryCrop}
          </div>
          <div style={sectionStyle}>
            <strong>Estimated Cultivation Area:</strong> {cultivationArea}
          </div>
          <div style={sectionStyle}>
            <strong>Other Suitable Crops:</strong>
            <ul style={{ marginTop: '8px', paddingLeft: '20px' }}>
              {suitableCrops.map((crop, idx) => (
                <li key={idx}>{getCropIcon(crop)} {crop}</li>
              ))}
            </ul>
          </div>
        </div>

        {/* Card 2: Crop Pattern Analysis */}
        <div 
          style={cardStyle}
          onMouseEnter={(e) => {
            e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)';
            e.currentTarget.style.transform = 'translateY(-2px)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.05)';
            e.currentTarget.style.transform = 'translateY(0)';
          }}
        >
          <div style={titleStyle}>
            <span>📈</span>
            <span>Crop Pattern Analysis</span>
          </div>
          <div style={sectionStyle}><strong>Last 3-Year Trend:</strong></div>
          <ul style={{ paddingLeft: '20px', marginBottom: '15px' }}>
            {trends.map((trend, idx) => (
              <li key={idx} style={{ marginBottom: '8px' }}>{trend}</li>
            ))}
          </ul>
          <div style={sectionStyle}>
            <strong>Current Production Focus:</strong>
            <div style={{ marginTop: '8px' }}>
              {getCropIcon(primaryCrop)} {primaryCrop}: {mapData.cropProduction?.[primaryCrop]?.toFixed(1) || 'N/A'} MT
            </div>
            {secondaryCrop !== 'N/A' && (
              <div style={{ marginTop: '5px' }}>
                {getCropIcon(secondaryCrop)} {secondaryCrop}: {mapData.cropProduction?.[secondaryCrop]?.toFixed(1) || 'N/A'} MT
              </div>
            )}
          </div>
          <div style={{ ...sectionStyle, marginTop: '15px', padding: '10px', backgroundColor: '#E8F5E9', borderRadius: '6px' }}>
            <strong>Future Suggestion:</strong> Diversify with high-yield crops and implement sustainable farming practices
          </div>
        </div>

        {/* Card 3: Soil Type Classification */}
        <div 
          style={cardStyle}
          onMouseEnter={(e) => {
            e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)';
            e.currentTarget.style.transform = 'translateY(-2px)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.05)';
            e.currentTarget.style.transform = 'translateY(0)';
          }}
        >
          <div style={titleStyle}>
            <span>🧪</span>
            <span>Soil Type Classification</span>
          </div>
          <div style={sectionStyle}>
            <strong>Predominant Soil Type:</strong> {soilInfo.type}
          </div>
          <div style={sectionStyle}><strong>Key Properties:</strong></div>
          <ul style={{ paddingLeft: '20px', marginBottom: '15px' }}>
            {soilInfo.properties.map((prop, idx) => (
              <li key={idx} style={{ marginBottom: '6px' }}>{prop}</li>
            ))}
          </ul>
          <div style={{ ...sectionStyle, padding: '10px', backgroundColor: '#FFF3E0', borderRadius: '6px' }}>
            <strong>💡 Recommendation:</strong> {soilInfo.recommendation}
          </div>
        </div>
      </div>

      {/* District-wise Summary */}
      {districtData && districtData.districts && districtData.districts.length > 0 && (
        <div style={{ marginTop: '30px' }}>
          <h4 style={{ fontSize: '20px', fontWeight: 'bold', marginBottom: '15px', color: '#2E7D32' }}>
            🗺️ {userRole === 'district' ? `${userSelectedDistrict} District Crop Details` : `District-wise Crop Summary for ${selectedState}`}
          </h4>
          
          
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
            gap: '15px',
          }}>
            {/* For district admin, show only their district; for others show multiple districts */}
            {(userRole === 'district' 
              ? districtData.districts.filter(d => d.district.toLowerCase() === userSelectedDistrict.toLowerCase())
              : districtData.districts.slice(0, 6)
            ).map((district, idx) => (
              <div 
                key={idx}
                style={{
                  padding: '15px',
                  backgroundColor: 'white',
                  borderRadius: '10px',
                  border: '1px solid #e0e0e0',
                  boxShadow: '0 2px 6px rgba(0,0,0,0.05)',
                }}
              >
                <div style={{ fontWeight: 'bold', marginBottom: '10px', color: '#2E7D32' }}>
                  📍 {district.district}
                </div>
                <div style={{ fontSize: '13px', marginBottom: '5px' }}>
                  <strong>Primary:</strong> {getCropIcon(district.primary)} {district.primary}
                </div>
                {district.secondary && (
                  <div style={{ fontSize: '13px' }}>
                    <strong>Secondary:</strong> {getCropIcon(district.secondary)} {district.secondary}
                  </div>
                )}
              </div>
            ))}
          </div>
          {userRole !== 'district' && districtData.districts.length > 6 && (
            <div style={{ textAlign: 'center', marginTop: '15px', color: '#666', fontSize: '14px' }}>
              + {districtData.districts.length - 6} more districts
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default SmartTools;


